import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import style from "./style";
import { LoadingButton } from "@mui/lab";
import "react-phone-input-2/lib/bootstrap.css";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import { ReactComponent as DownArrow } from "../../../../../assets/AccountingModule/arrow_down.svg";
import TextField from "@mui/material/TextField";
import color from "../../../../../constants/color";
import { addNewCustomerData } from "../../../../../constants/data";
import { useForm } from "../../../../../hooks/useForm";
import CustomInput from "../../../.././../components/CustomInput";
import { addNewCustomerValidation } from "../../../../../helper/Validation";

const AddNewCustomersPage = ({ loading, handleAddNewCustomer }) => {
  const navigate = useNavigate();
  const options = countryList().getData();
  const [isBlocked, setIsBlocked] = useState(false);
  // Billing Address
  const [billingCountry, setBillingCountry] = useState("");
  const [billingStreet1, setBillingStreet1] = useState("");
  const [billingStreet2, setBillingStreet2] = useState("");
  const [billingCity, setBillingCity] = useState("");
  const [billingState, setBillingState] = useState("");
  const [billingPinCode, setBillingPinCode] = useState("");
  const [billingPhone, setBillingPhone] = useState("");

  // Shipping Address
  const [shippingCountry, setShippingCountry] = useState("");
  const [shippingStreet1, setShippingStreet1] = useState("");
  const [shippingStreet2, setShippingStreet2] = useState("");
  const [shippingCity, setShippingCity] = useState("");
  const [shippingState, setShippingState] = useState("");
  const [shippingPinCode, setShippingPinCode] = useState("");
  const [shippingPhone, setShippingPhone] = useState("");

  const handleAddCustomerData = async (formState) => {
    const finalData = {
      name: formState.name.value,
      companyName: formState.companyName.value,
      email: formState.email.value,
      phone: formState.phone.value,
      taxId: formState.taxId.value,
      creditLimits: formState.creditLimits.value,
      isBlocked: isBlocked,
      billingAddress: {
        country: billingCountry,
        street1: billingStreet1,
        street2: billingStreet2,
        city: billingCity,
        state: billingState,
        pinCode: billingPinCode,
        phone: billingPhone,
      },
      shippingAddress: {
        country: shippingCountry,
        street1: shippingStreet1,
        street2: shippingStreet2,
        city: shippingCity,
        state: shippingState,
        pinCode: shippingPinCode,
        phone: shippingPhone,
      },
    };
    handleAddNewCustomer(finalData);
    navigate("/dashboard/customer");
  };

  useEffect(() => {
    if (window.intlTelInputGlobals) {
      window.intlTelInputGlobals.loadUtils("build/js/utils.js");
    }
  }, []);

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === "dark" ? "#177ddc" : "#28AA4A",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,.35)"
          : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    addNewCustomerData,
    addNewCustomerValidation,
    handleAddCustomerData
  );

  let { name, companyName, email, phone, taxId, creditLimits, street1, pinCode,
    city, state1, state2, street2, city2, pinCode1 } = state;

  const handleCopyBillingToShipping = () => {
    // Copy all billing fields to shipping fields
    setShippingCountry(billingCountry);
    setShippingStreet1(billingStreet1);
    setShippingStreet2(billingStreet2);
    setShippingCity(billingCity);
    setShippingState(billingState);
    setShippingPinCode(billingPinCode);
    setShippingPhone(billingPhone);
  };

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Add New Customer</Typography>
        </Box>
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container>
          <Grid item xs={12} lg={11.7} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="name"
                  error={name?.error}
                  placeholder="Enter Name"
                  name="name"
                  value={name?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="name"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Company Name</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="companyName"
                  error={companyName?.error}
                  placeholder="Enter Company Name"
                  name="companyName"
                  value={companyName?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="email"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Email</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  error={email?.error}
                  placeholder="Enter Email"
                  name="email"
                  value={email?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="email"
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <FormControl fullWidth sx={style.countryCode}>
                  <Typography sx={style.inputText}>Phone</Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    id="phone"
                    name="phone"
                    error={phone?.error}
                    placeholder="Enter phone number with country code"
                    value={phone?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="phone"
                  />
                </FormControl>
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Tax Id</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="taxId"
                  error={taxId?.error}
                  placeholder="Enter Tax Id"
                  name="taxId"
                  value={taxId?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="taxId"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Credit Limits</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="creditLimits"
                  error={creditLimits?.error}
                  name="creditLimits"
                  placeholder="Enter Credit Limits"
                  value={creditLimits?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="creditLimits"
                />
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Box sx={style.switchBox}>
                  <Typography sx={style.inputText}>
                    Customer Block/Unblock
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch
                      checked={isBlocked}
                      onChange={(e) => {
                        setIsBlocked(e.target.checked);
                      }}
                    />
                  </Stack>
                </Box>
              </Box>
              <Box sx={style.inputBox}></Box>
            </Box>
          </Grid>
        </Grid>

        <Box px="15px" mt={2}>
          <Box sx={style.headerContainer}>
            <Typography sx={style.leaveHeading}>Address</Typography>
          </Box>
        </Box>
        <Grid container>
          <Grid item xs={12} lg={11.7} sx={style.gridbox}>
            <Box sx={style.addressBox}>
              <Box sx={{ width: "50%" }}>
                <Typography sx={{ fontWeight: "Bold" }}>
                  Billing Address
                </Typography>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>
                      Country/Region
                    </Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <FormControl fullWidth required sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px"
                      }
                    }}>
                      <Select
                        value={billingCountry || ""}
                        onChange={(event) => setBillingCountry(event.target.value)}
                        name="billingCountry"
                        sx={style.dropDownMenu}
                        onFocus={handleFocus}
                        displayEmpty
                      >
                        <MenuItem disabled value="">Select</MenuItem>
                        {options.map((country, index) => (
                          <MenuItem key={index} sx={style.dropDownMenu} value={country.label}>{country.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Address</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      placeholder="Street 1"
                      name="street1"
                      value={billingStreet1}
                      onChange={(e) => { setBillingStreet1(e.target.value); }}
                      onFocus={handleFocus}
                      autoComplete="bstreet1"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Street 2"
                      value={billingStreet2}
                      onChange={(e) => setBillingStreet2(e.target.value)}
                      error={false}
                      onFocus={handleFocus}
                      autoComplete="bstreet2"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                          marginTop: "24px"
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>City</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="city"
                      placeholder="City"
                      value={billingCity}
                      onChange={(e) => setBillingCity(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="city"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>State</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="state1"
                      placeholder="State"
                      value={billingState}
                      onChange={(e) => setBillingState(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="bstate"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Pin Code</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name={"pinCode"}
                      placeholder="Pin Code"
                      value={billingPinCode}
                      onChange={(e) => setBillingPinCode(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="spinCode"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Phone</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      placeholder="Phone"
                      value={billingPhone}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setBillingPhone(value);
                      }}
                      onFocus={handleFocus}
                      autoComplete="bphone"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                        inputProps: {
                          pattern: "[0-9]*",
                          inputMode: "numeric"
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ width: "50%" }}>
                <Box sx={{ display: "flex", gap: "8px" }}>
                  <Typography sx={{ fontWeight: "Bold" }}>
                    Shipping Address
                  </Typography>
                  <Typography
                    sx={{ color: color.secondary, cursor: "pointer" }}
                    onClick={handleCopyBillingToShipping}
                  >
                    {"( "}
                    <DownArrow /> Copy Billing Address{" )"}
                  </Typography>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>
                      Country/Region
                    </Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <FormControl fullWidth required sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px"
                      }
                    }}>
                      <Select
                        value={shippingCountry || ""}
                        onChange={(event) => setShippingCountry(event.target.value)}
                        name="shippingCountry"
                        sx={style.dropDownMenu}
                        onFocus={handleFocus}
                        displayEmpty
                      >
                        <MenuItem disabled value="">Select</MenuItem>
                        {options.map((country, index) => (
                          <MenuItem key={index} sx={style.dropDownMenu} value={country.label}>{country.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Address</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      placeholder="Street 1"
                      name="street2"
                      value={shippingStreet1}
                      onChange={(e) => setShippingStreet1(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="bstreet1"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                          // marginTop: "24px"
                        },
                      }}
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Street 2"
                      value={shippingStreet2}
                      onChange={(e) => setShippingStreet2(e.target.value)}
                      error={false}
                      onFocus={handleFocus}
                      autoComplete="sstreet2"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                          marginTop: "24px"
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>City</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="city2"
                      placeholder="City"
                      value={shippingCity}
                      onChange={(e) => setShippingCity(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="scity"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>State</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="state2"
                      placeholder="State"
                      value={shippingState}
                      onChange={(e) => setShippingState(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="bstate"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Pin Code</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="pinCode1"
                      placeholder="Pin Code"
                      value={shippingPinCode}
                      onChange={(e) => setShippingPinCode(e.target.value)}
                      onFocus={handleFocus}
                      autoComplete="spinCode"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={style.addressInput}>
                  <Box sx={{ width: "20%" }}>
                    <Typography sx={style.inputText}>Phone</Typography>
                  </Box>
                  <Box sx={{ width: "75%" }}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      placeholder="Phone"
                      value={shippingPhone}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setShippingPhone(value);
                      }}
                      error={false}
                      onFocus={handleFocus}
                      autoComplete="sphone"
                      sx={style.addressTextField}
                      InputProps={{
                        sx: {
                          fontSize: "14px",
                          fontWeight: 400,
                        },
                        inputProps: {
                          pattern: "[0-9]*",
                          inputMode: "numeric"
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <LoadingButton
              loading={loading}
              variant="contained"
              type="submit"
              color="success"
              disabled={
                !name?.value ||
                name?.error ||
                !email?.value ||
                email?.error ||
                !phone?.value ||
                phone?.error ||
                taxId?.error ||
                !creditLimits?.value ||
                creditLimits?.error ||
                !billingCountry ||
                !billingStreet1 ||
                !billingCity ||
                !billingState ||
                !billingPinCode ||
                !billingPhone ||
                !shippingCountry ||
                !shippingStreet1 ||
                !shippingCity ||
                !shippingState ||
                !shippingPinCode ||
                !shippingPhone
              }
              sx={{ ...style.jobButtons, mb: 3 }}
            >
              Save as New
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </>
  );
};
export default AddNewCustomersPage;
